<template>
  <div :class="['checkbox-card', { checked: modelValue, disabled }]">
    <label class="checkbox-card-header">
      <input
        type="checkbox"
        class="form-check-input"
        :checked="modelValue"
        :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <div class="checkbox-card-text">
        <div class="checkbox-card-label">{{ label }}</div>
        <div v-if="sublabel" class="checkbox-card-sublabel">{{ sublabel }}</div>
        <slot />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    label: String,
    sublabel: String,
    disabled: Boolean
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.checkbox-card {
  border: 1px solid var(--bs-border-color);
  border-radius: 7px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.checkbox-card:hover:not(.disabled) {
  border-color: var(--bs-gray-500);
}
.checkbox-card.checked {
  border-color: var(--bs-dark);
}
.checkbox-card.disabled {
  opacity: 0.6;
  cursor: default;
}
.checkbox-card-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  margin-bottom: 0;
}
.checkbox-card.disabled .checkbox-card-header {
  cursor: default;
}
.checkbox-card .form-check-input {
  margin-top: 2px;
  flex-shrink: 0;
}
.checkbox-card .form-check-input:checked {
  background-color: var(--bs-dark);
  border-color: var(--bs-dark);
}
.checkbox-card-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.checkbox-card-label {
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
}
.checkbox-card-sublabel {
  font-weight: 400;
  font-size: 0.8rem;
  color: var(--bs-secondary-color);
  line-height: 1.3;
}
</style>
